import {createContext, FC, useContext, useState} from 'react'
import {WithChildren} from '@/_metronic/helpers'
import {BaseRequest} from '@/_metronic/helpers/crud-helper/base-request'
import { FilterSubscriptionCustomer, initialFilterSubscriptionCustomer } from './_models'

type SubscriptionCustomerQueryRequestContextProps = {
  state: BaseRequest<FilterSubscriptionCustomer>
  updateState: (updates: Partial<BaseRequest<FilterSubscriptionCustomer>>) => void
}

const initialQueryRequest = {
  state: initialFilterSubscriptionCustomer,
  updateState: () => {},
}

const QueryRequestContext = createContext<SubscriptionCustomerQueryRequestContextProps>(initialQueryRequest)

const CustomerRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<BaseRequest<FilterSubscriptionCustomer>>(initialQueryRequest.state)

  const updateState = (updates: Partial<BaseRequest<FilterSubscriptionCustomer>>) => {
    const updatedState = {...state, ...updates} as BaseRequest<FilterSubscriptionCustomer>
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useCustomerRequest = () => useContext(QueryRequestContext)
export {CustomerRequestProvider, useCustomerRequest}
